import TextInput from "components/controls/TextInput";
import { useForm } from "modules/forms";
import { StyledControlContainer } from "shared/styled/control.styled";
import { StyledPanelTitle } from "shared/styled/panel.stayled";
import { GoodPracticeEntity } from "shared/types/domain/GoodPracticeEntity";
import { useTranslation } from 'react-i18next';

interface GoodPracticeDetailsProps {
    readOnly: boolean;
};

const GoodPracticeDetails = ({
    readOnly
}: GoodPracticeDetailsProps) => {

    const { formData, updateFields, formErrors } = useForm<GoodPracticeEntity>();
    const { t } = useTranslation();

    return (
        <>
            <StyledPanelTitle>{t('ObservationPage.ExplanationOfGoodPractice')}</StyledPanelTitle>

            <StyledControlContainer>
                <TextInput
                    label={t('ObservationList.Details')}
                    multiline
                    value={formData?.whatHappened}
                    errorMessage={formErrors?.whatHappened}
                    onChange={(e, v) => updateFields({
                        whatHappened: { runValidation: true, value: v }
                    })}
                    disabled={readOnly}
                    required
                />
            </StyledControlContainer>

            <StyledControlContainer>
                <TextInput
                    label={t('ObservationPage.WhoCommended')}
                    multiline
                    value={formData?.whoShouldBeCommended}
                    errorMessage={formErrors?.whoShouldBeCommended}
                    onChange={(e, v) => updateFields({
                        whoShouldBeCommended: { runValidation: true, value: v }
                    })}
                    disabled={readOnly}
                    required
                />
            </StyledControlContainer>
        </>
    )
};

export default GoodPracticeDetails;